import { PERMISSIONS } from "../roles-permissions/permission-catalog";
import { defineEntityIdentity } from "../_shared/entity-identity.schemas";

export const companiesIdentity = defineEntityIdentity({
	definitionKey: "companies",
	pageKey: "companies",
	nameSingular: "company",
	namePlural: "companies",
	relationKey: "company",
	auditKey: "companies",
	storage: "durable",
	grants: {
		read: { ...PERMISSIONS.companies.readAll, audience: "allMembers" },
		create: {
			...PERMISSIONS.companies.createAll,
			audience: "restricted",
			assignByEmail: ["cgoebel@fergmar.com", "bferguson@fergmar.com"]
		},
		update: {
			...PERMISSIONS.companies.updateAll,
			audience: "restricted",
			assignByEmail: ["cgoebel@fergmar.com", "bferguson@fergmar.com"]
		},
		delete: { ...PERMISSIONS.companies.deleteAll, audience: "restricted" }
	}
});

export const companyStructureIdentity = defineEntityIdentity({
	definitionKey: "company-structure",
	pageKey: null,
	nameSingular: "companyStructure",
	namePlural: "companyStructures",
	relationKey: null,
	auditKey: "company-structure",
	storage: "durable",
	grants: {
		read: {
			...PERMISSIONS.companyStructure.readAll,
			audience: "restricted",
			assignByEmail: ["cgarner@fergmar.com", "cgoebel@fergmar.com", "bferguson@fergmar.com"]
		},
		create: {
			...PERMISSIONS.companyStructure.manageAll,
			audience: "restricted",
			assignByEmail: ["cgarner@fergmar.com", "cgoebel@fergmar.com", "bferguson@fergmar.com"]
		},
		update: {
			...PERMISSIONS.companyStructure.manageAll,
			audience: "restricted",
			assignByEmail: ["cgarner@fergmar.com", "cgoebel@fergmar.com", "bferguson@fergmar.com"]
		},
		delete: null
	}
});
